import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { GeneralModal, GeneralModalNoButtonVariant } from '../GeneralModal';
import { Icons, IconType } from '../../../../constants/icons';
import { FillPNGIcon } from '../../FillPNGIcon';
import './GameTypeHelpModal.css';

export enum GameTypeHelpType {
  Assisted = 'assisted',
  Spelling = 'spelling',
  Syllable = 'syllable',
  JoyaPassage = 'joyaPassage',
}

export const stringToGameTypeHelpType = (
  str: string | undefined | null,
): GameTypeHelpType | undefined => {
  switch (str) {
    case 'assisted':
      return GameTypeHelpType.Assisted;
    case 'spelling':
      return GameTypeHelpType.Spelling;
    case 'syllable':
      return GameTypeHelpType.Syllable;
    case 'joyaPassage':
      return GameTypeHelpType.JoyaPassage;
    default:
      return undefined;
  }
};

type GameTypeHelpModalProps = {
  type: GameTypeHelpType;
  onClose: () => void;
};

const gameTypeHelpInfo: Record<
  GameTypeHelpType,
  { title: string; description: string; icon: IconType }
> = {
  [GameTypeHelpType.Assisted]: {
    title: 'Gamified Tutorial',
    description: 'Guide you to learn step by step.',
    icon: IconType.TutorGame,
  },
  [GameTypeHelpType.Spelling]: {
    title: 'Spelling JOY · By Characters',
    description: 'Learn word by spelling.', // TODO
    icon: IconType.GameTypeSpellingBig,
  },
  [GameTypeHelpType.Syllable]: {
    title: 'Spelling JOY · By Syllables',
    description: 'Learn components of the word before spelling.',
    icon: IconType.GameTypeSpellSyllable,
  },
  [GameTypeHelpType.JoyaPassage]: {
    title: 'Quick Memory JOY',
    description: 'Memorize Text Content.', // TODO
    icon: IconType.GameTypeJoyAPassage,
  },
};

export const GameTypeHelpModal = memo(
  ({ type, onClose }: GameTypeHelpModalProps) => {
    const { t } = useTranslation();
    const info = gameTypeHelpInfo[type];

    return (
      <GeneralModal
        onClose={onClose}
        buttonSetting={{
          noText: t('OK'),
          noVariant: GeneralModalNoButtonVariant.Cyan,
        }}
      >
        <div className="game-type-help-modal">
          <div className="centered-container">
            <FillPNGIcon src={Icons[info.icon]} color="#000000" size={72} />
            <div className="modal-title"> {t(info.title)}</div>
            <div className="modal-description">{t(info.description)}</div>
          </div>
        </div>
      </GeneralModal>
    );
  },
);
